import MissingSomethingModalButton, { type IProps } from './MissingSomethingModalButton';
import MissingSomethingModalProvider from '@/creditflowresearch/application/MissingSomethingModalContext';
import MissingSomethingModalForm from '@/creditflowresearch/ui/common/components/MissingSomethingModalForm';

const MissingSomethingModalButtonWithProvider = (props: IProps) => (
  <MissingSomethingModalProvider>
    <MissingSomethingModalButton { ...props } />
    <MissingSomethingModalForm />
  </MissingSomethingModalProvider>
);

export default MissingSomethingModalButtonWithProvider;
